<template>
 <div class="help-fourth-page">
 <div class="paytable-content" data-langname="paytable">
  </div>
  <div class="b-49-pg-1-table-holder">
    <b-table striped :items="items1" :fields="fields1"></b-table>
    <b-table striped :items="items2" :fields="fields2"></b-table>
    <b-table striped :items="items3" :fields="fields3"></b-table>
  </div>
  <div class="b-35-pg-8-right-text" data-langname="max-per-ticket" />
</div>
</template>

<script>
  export default {
    data() {
      return {
        // Note `isActive` is left out and will not appear in the rendered table
        fields1: [
           {key: 'matched_on', label: this.$route.query.lang === 'en' ? 'Matched On' : 'Pogodak na broju', class: 'text-center'},
          {key: 'bet_multiplier', label: this.$route.query.lang === 'en' ? 'Bet Multiplier' : 'Kvota', class: 'text-center'},
        ],
        items1: [
          { isActive: true, matched_on: '6.', bet_multiplier: 'x 10.000' },
          { isActive: false, matched_on: '7.', bet_multiplier: 'x 7.500' },
          { isActive: true, matched_on: '8.', bet_multiplier: 'x 5.000' },
          { isActive: false, matched_on: '9.', bet_multiplier: 'x 2.500' },
          { isActive: true, matched_on: '10.', bet_multiplier: 'x 1.000' },
          { isActive: false, matched_on: '11.', bet_multiplier: 'x 500' },
          { isActive: true, matched_on: '12.', bet_multiplier: 'x 300' },
          { isActive: false,matched_on: '13.', bet_multiplier: 'x 200' },
          { isActive: true,  matched_on: '14.', bet_multiplier: 'x 150' },
          { isActive: false, matched_on: '15.', bet_multiplier: 'x 100' }
        ],
        fields2: [
          {key: 'matched_on', label: this.$route.query.lang === 'en' ? 'Matched On' : 'Pogodak na broju', class: 'text-center'},
          {key: 'bet_multiplier', label: this.$route.query.lang === 'en' ? 'Bet Multiplier' : 'Kvota', class: 'text-center'},
        ],
        items2: [
          { isActive: true, matched_on: '16.', bet_multiplier: 'x 90' },
          { isActive: false, matched_on: '17.', bet_multiplier: 'x 80' },
          { isActive: true, matched_on: '18.', bet_multiplier: 'x 70' },
          { isActive: false, matched_on: '19.', bet_multiplier: 'x 60' },
          { isActive: true, matched_on: '20.', bet_multiplier: 'x 50' },
          { isActive: false, matched_on: '21.', bet_multiplier: 'x 40' },
          { isActive: true, matched_on: '22.', bet_multiplier: 'x 30' },
          { isActive: false,matched_on: '23.', bet_multiplier: 'x 25' },
          { isActive: true,  matched_on: '24.', bet_multiplier: 'x 20' },
          { isActive: false, matched_on: '25.', bet_multiplier: 'x 15' }
        ],
        fields3: [
          {key: 'matched_on', label: this.$route.query.lang === 'en' ? 'Matched On' : 'Pogodak na broju', class: 'text-center'},
          {key: 'bet_multiplier', label: this.$route.query.lang === 'en' ? 'Bet Multiplier' : 'Kvota', class: 'text-center'},
        ],
        items3: [
          { isActive: true, matched_on: '26.', bet_multiplier: 'x 10' },
          { isActive: false, matched_on: '27.', bet_multiplier: 'x 9' },
          { isActive: true, matched_on: '28.', bet_multiplier: 'x 8' },
          { isActive: false, matched_on: '29.', bet_multiplier: 'x 7' },
          { isActive: true, matched_on: '30.', bet_multiplier: 'x 6' },
          { isActive: false, matched_on: '31.', bet_multiplier: 'x 5' },
          { isActive: true, matched_on: '32.', bet_multiplier: 'x 4' },
          { isActive: false,matched_on: '33.', bet_multiplier: 'x 3' },
          { isActive: true,  matched_on: '34.', bet_multiplier: 'x 2' },
          { isActive: false, matched_on: '35.', bet_multiplier: 'x 1' }
        ]
      }
    }
  }
</script>